import React from 'react';
import classnames from 'classnames';

import RichText from 'dpl/prismic/components/RichText';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import { ARTICLE_CONTENT_COL_CLASSES } from 'dpl/prismic/article/utils/constants';

export default function PullQuoteInline({ content }) {
  return (
    <div
      className={classnames(
        'PrismicPullQuoteInline',
        ARTICLE_CONTENT_COL_CLASSES
      )}
    >
      <div className="pl15 pv5 fw-medium f4 purple bl bw2">
        &ldquo;{RichText.asText(content)}&rdquo;
      </div>
    </div>
  );
}

PullQuoteInline.propTypes = {
  content: StructuredTextPropTypes.isRequired
};
